import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function FormatCodeUpsert(param: any) {

    console.log(param)
    let [FormatCode, setFormatCode] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            FormatCode = param?.editDataDawer
            setFormatCode(FormatCode)
        }
    }

    const onSave = () => {
        systemFormatsList.saveFormat(FormatCode).then((respond: any) => {
            CommonUtilities.showToastDawer('Payee Status Saved', 'Success')
        })
    }

    return (<>

        <Drawer open={param.editDawer} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5  box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Format Code</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    {/* Body */}
                    <div className="ws-12">
                        {/* Row 1 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">
                                Code<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={FormatCode.code} onChange={(e: any) => setFormatCode({ ...FormatCode, code: e.target.value })} placeholder="Enter code" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">
                                DIM 1<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={FormatCode.dim1} onChange={(e: any) => setFormatCode({ ...FormatCode, dim1: e.target.value })} placeholder="Enter DIM 1" />
                        </div>

                        {/* Row 2 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">
                                FormatCode /Source Codes<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={FormatCode.FormatCodeSource} onChange={(e: any) => setFormatCode({ ...FormatCode, FormatCodeSource: e.target.value })} placeholder="Enter FormatCode/ source codes"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">  DIM 2<span className="ac-required">*</span>  </label>
                            <input className="ws-11" value={FormatCode.dim2} onChange={(e: any) => setFormatCode({ ...FormatCode, dim2: e.target.value })} placeholder="Enter DIM 2"
                            />
                        </div>

                        {/* Row 3 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">Mechanicals<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={FormatCode.mechanicals} onChange={(e: any) => setFormatCode({ ...FormatCode, mechanicals: e.target.value })} placeholder="Enter mechanicals"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">DIM 3<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={FormatCode.dim3} onChange={(e: any) => setFormatCode({ ...FormatCode, dim3: e.target.value })} placeholder="Enter DIM 3"
                            />
                        </div>

                        {/* Row 4 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">Part FormatCode </label>
                            <input className="ws-11" value={FormatCode.partFormatCode || ""} disabled placeholder="No Part FormatCodeAvailable" onChange={(e: any) => setFormatCode({ ...FormatCode, partFormatCode: e.target.value })} />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">   Cat Format Code<span className="ac-required">*</span>  </label>
                            <input className="ws-11" value={FormatCode.FormatCode} onChange={(e: any) => setFormatCode({ ...FormatCode, FormatCode: e.target.value })} placeholder="Enter cat Format Code" />
                        </div>

                        {/* Row 5 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold"> Parent Group<span className="ac-required">*</span> </label>
                            <select className="ws-11" value={FormatCode.parentGroup} onChange={(e: any) => setFormatCode({ ...FormatCode, parentGroup: e.target.value })}>
                                <option value="">Choose Parent Group</option>
                                <option value="Digital">Digital</option>
                                <option value="Video">Video</option>
                                <option value="Physical">Physical</option>
                            </select>
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold"> Esc Rate Album<span className="ac-required">*</span>  </label>
                            <input className="ws-11" value={FormatCode.escRateAlbum} onChange={(e: any) => setFormatCode({ ...FormatCode, escRateAlbum: e.target.value })} placeholder="Enter Escalate Rate Album" />
                        </div>

                        {/* Row 6 */}
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">Cat FormatCode <span className="ac-required">*</span></label>
                            <input className="ws-11" value={FormatCode.catFormatCode} onChange={(e: any) => setFormatCode({ ...FormatCode, catFormatCode: e.target.value })} placeholder="Enter cat FormatCode " />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">Esc Rate Track<span className="ac-required">*</span> </label>
                            <input className="ws-11" value={FormatCode.escRateTrack} onChange={(e: any) => setFormatCode({ ...FormatCode, escRateTrack: e.target.value })} placeholder="Enter Escalate Rate Tracks" />
                        </div>

                        <div className="ws-6 ps" />
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">FormatCode Report</label>
                            <input className="ws-11" value={FormatCode.FormatCodeReport} onChange={(e: any) => setFormatCode({ ...FormatCode, FormatCodeReport: e.target.value })} placeholder="Enter FormatCodereport" />
                        </div>
                    </div>


                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}